import { TypedDocumentNode } from "@apollo/client";
import { OperationVariables } from "@apollo/client/core";
import { QueryHookOptions } from "@apollo/client/react/types/types";
import { useBaseFetchQuery, UseBaseFetchQueryReturnType } from "@flaminem/utils";

import { useCreateError } from "src/errors";

import { ErrorCode } from "./errorBuilder.ts";

export const useFetchQuery = <
  TData,
  TReturn,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: TypedDocumentNode<TData, TVariables>,
  config: {
    toData: (data: TData | undefined) => TReturn;
    isEmpty: (data: TData | undefined) => boolean;
    uiErrors: { fetchError: ErrorCode; emptyError?: ErrorCode };
    queryOptions?: QueryHookOptions<TData, TVariables>;
  }
): UseBaseFetchQueryReturnType<TReturn, TData, ErrorCode, TVariables> => {
  const createError = useCreateError();
  return useBaseFetchQuery(query, {
    ...config,
    errorBuilder: createError,
  });
};
